import React from "react";
import { Card, Tag, Divider } from "antd";
import QuestionTextProvider from "Components/CommonComponents/QuestionTextProvider";

interface Choice {
  choiceId: string;
  text: string;
  is_answer: boolean;
}

interface QuestionData {
  language?: string;
  status?: string;
  questionId?: number;
  question?: {
    text: string;
    choices: Choice[];
  };
  solution?: string;
}

interface Props {
  question?: QuestionData;
}

const QuestionPreview: React.FC<Props> = ({ question }: any) => {
  const { question: q, solution, language, status } = question || {};

  const correctChoice = q?.choices?.find((c: any) => c.is_answer) || undefined;

  return (
    <Card style={{ width: "100%" }}>
      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div>
          <strong>{question.questionId}</strong>{" "}
          <Tag color={status === "Published" ? "green" : "orange"}>
            {status?.toUpperCase()}
          </Tag>
        </div>
        <Tag>{language === "en" ? "English" : language}</Tag>
      </div>
      <Divider />
      {/* Question */}
      <h3>Question :</h3>
      <QuestionTextProvider content={q.text}></QuestionTextProvider>
      {/* Options */}
      <Divider />
      {q?.choices &&
        q.choices?.length &&
        q.choices.map((choice: any) => (
          <div
            key={choice.choiceId}
            style={{
              display: "flex",
              gap: 12,
              padding: "8px 0",
              background: choice.is_answer ? "#f6ffed" : "transparent",
            }}
          >
            <strong>{choice.choiceId}</strong>
            <QuestionTextProvider content={choice.text}></QuestionTextProvider>
          </div>
        ))}
      {/* Correct Answer */}
      {correctChoice && (
        <>
          <Divider />
          <h3>Correct Answer:</h3>
          <QuestionTextProvider
            content={correctChoice.text}
          ></QuestionTextProvider>
        </>
      )}
      {/* Solution */}
      {solution && (
        <>
          <Divider />
          <h3>Solution:</h3>
          <QuestionTextProvider content={solution}></QuestionTextProvider>
        </>
      )}
      {/* Language */}
      <Divider />
      <strong>Question Language :</strong> {language}
    </Card>
  );
};

export default QuestionPreview;
